import React from "react";

const CXContactCenterLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section
                className="relative h-[520px] flex items-center text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.85), rgba(2,6,23,.85)), url(https://images.unsplash.com/photo-1581090700227-1e37b190418e)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="relative w-full px-6 md:px-16 lg:px-24 py-24 text-white text-left">
                    <span className="text-sm uppercase text-orange-400 tracking-wide">
                        Services
                    </span>
                    <h1 className="text-4xl md:text-5xl font-bold mt-3 max-w-3xl">
                        Reimagine Customer Experience with AI-Native Contact Center
                    </h1>
                    <p className="mt-4 max-w-2xl text-gray-200">
                        Transform every customer interaction with intelligent automation,
                        actionable insights, and AI-driven engagement.
                    </p>
                    <button className="mt-6 bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-md font-semibold">
                        Consult our Experts
                    </button>
                </div>
            </section>

            {/* ================= CX REALITY ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-6">The New CX Reality</h2>
                    <p className="max-w-4xl text-gray-700 mb-4">
                        Customer expectations are evolving rapidly. Enterprises must deliver
                        seamless, personalized, and consistent experiences across channels.
                    </p>
                    <p className="max-w-4xl text-gray-700">
                        AI-native contact centers enable proactive engagement, real-time
                        insights, and continuous optimization across the customer journey.
                    </p>
                </div>
            </section>

            {/* ================= CONTACT CENTER CAPABILITIES ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">
                        Intelligent Contact Center Capabilities
                    </h2>

                    <div className="grid md:grid-cols-5 gap-6">
                        {[
                            "Conversational AI",
                            "Omnichannel Engagement",
                            "Intelligent Routing",
                            "Customer Insights",
                            "Experience Analytics",
                            "Unified Customer View",
                            "AI-Assisted Agents",
                            "CRM Integration",
                            "Cloud Contact Center",
                            "Agent Productivity",
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="bg-white border rounded-xl p-5 shadow-sm text-center"
                            >
                                <div className="w-12 h-12 mx-auto bg-orange-100 rounded-full mb-4" />
                                <p className="text-sm font-medium">{item}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= GOOGLE CLOUD ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.9), rgba(2,6,23,.9)), url(https://images.unsplash.com/photo-1518770660439-4636190af475)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold max-w-2xl">
                        AI-Powered CX Strategies for Industries with Google Cloud
                    </h2>
                    <button className="mt-6 bg-orange-500 px-6 py-3 rounded-md">
                        Download the Report
                    </button>
                </div>
            </section>

            {/* ================= PROSERV ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div className="md:col-span-2">
                        <h2 className="text-3xl font-bold mb-4">
                            Contact Center ProServ
                        </h2>
                        <p className="text-gray-700">
                            Modernize your contact center with AI-driven workflows, cloud-native
                            platforms, and data-led experience orchestration.
                        </p>
                    </div>

                    <div className="bg-[#020617] text-white rounded-xl p-6">
                        <h4 className="font-semibold mb-3">Our Offerings</h4>
                        <ul className="text-sm space-y-2 text-gray-300">
                            <li>• CX Platform Modernization</li>
                            <li>• Conversational AI</li>
                            <li>• Agent Assist Solutions</li>
                            <li>• Omnichannel Integration</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* ================= FUTURE CX ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.85), rgba(2,6,23,.85)), url(https://images.unsplash.com/photo-1517245386807-bb43f82c33c4)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold max-w-2xl">
                        Reimagining the Future of AI-Driven Customer Experience
                    </h2>
                    <button className="mt-6 bg-white text-black px-6 py-3 rounded-md">
                        Learn more
                    </button>
                </div>
            </section>

            {/* ================= CREDENTIALS ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-5 gap-6 text-center">
                    {[
                        ["2000+", "Professionals"],
                        ["20+", "Years of Delivery"],
                        ["5+", "CX Platforms"],
                        ["10+", "Cloud Partners"],
                        ["30+", "Global Customers"],
                    ].map(([num, label]) => (
                        <div key={label}>
                            <h3 className="text-3xl font-bold text-orange-500">{num}</h3>
                            <p className="text-sm text-gray-600">{label}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= WHY TechSPR ================= */}
            <section className="py-20 bg-[#fde7d9]">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
                    {[
                        "Deep Technology Expertise",
                        "Extensive Partner Ecosystem",
                        "Composable Data-Driven CX",
                    ].map((item) => (
                        <div key={item}>
                            <h4 className="font-semibold mb-2">{item}</h4>
                            <p className="text-sm text-gray-700">
                                Delivering measurable CX outcomes with AI-led innovation.
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= NEWS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">News & Insights</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            {
                                title: "How AI Is Reshaping Enterprise Digital Transformation",
                                img: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7",
                            },
                            {
                                title: "Building Secure & Scalable Cloud Infrastructure in 2025",
                                img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
                            },
                            {
                                title: "Open Source Strategy: Reducing Costs Without Risk",
                                img: "https://images.unsplash.com/photo-1526378722484-bd91ca387e72",
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="bg-white text-black rounded-xl overflow-hidden shadow-lg"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover"
                                />

                                <div className="p-5">
                                    <p className="text-sm font-medium">
                                        {item.title}
                                    </p>

                                    <button className="mt-3 text-orange-600 text-sm font-semibold hover:underline">
                                        Read the blog →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= CONTACT ================= */}
            {/* <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact us</h2>
                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            rows="4"
                            placeholder="How can we help?"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md">
                            Submit
                        </button>
                    </form>
                </div>
            </section> */}

        </div>
    );
};

export default CXContactCenterLayout;
